import {
  AlertStatus,
  ApplicationStatusTypeId,
  ApplicationTaskStatusTypeId,
  EventRegistrationStatus,
  EventStatusTypeId,
  FacilityStatusType,
  MemberEmployerStatusType,
  MemberStatusType,
  TaxRateType,
} from '../../../../core';
import { StatusPillType } from './status-pill-type.enum';
import { InvoiceStatusType } from '../../../../core';

export class StatusPillHelper {
  static getStatusPillTypeForApplicationStatus(
    applicationStatusId: ApplicationStatusTypeId | null | undefined,
  ): StatusPillType {
    switch (applicationStatusId) {
      case ApplicationStatusTypeId.Pending:
        return StatusPillType.yellow;
      case ApplicationStatusTypeId.Approved:
        return StatusPillType.green;
      case ApplicationStatusTypeId.Denied:
        return StatusPillType.red;
      case ApplicationStatusTypeId.Expired:
      default:
        return StatusPillType.grey;
    }
  }

  static getStatusPillTypeForApplicationTaskStatus(
    applicationTaskStatusId: ApplicationTaskStatusTypeId | null | undefined,
  ): StatusPillType {
    switch (applicationTaskStatusId) {
      case ApplicationTaskStatusTypeId.Pending:
      case ApplicationTaskStatusTypeId.Submitted:
        return StatusPillType.yellow;
      case ApplicationTaskStatusTypeId.Passed:
      case ApplicationTaskStatusTypeId.Verified:
        return StatusPillType.green;
      case ApplicationTaskStatusTypeId.Failed:
        return StatusPillType.red;
      case ApplicationTaskStatusTypeId.Exempt:
        return StatusPillType.blue;
      default:
        return StatusPillType.grey;
    }
  }

  static getStatusPillTypeForMemberStatus(memberStatusId: MemberStatusType | null | undefined): StatusPillType {
    switch (memberStatusId) {
      case MemberStatusType.active:
        return StatusPillType.green;
      case MemberStatusType.leaveOfAbsence:
        return StatusPillType.yellow;
      case MemberStatusType.deceased:
        return StatusPillType.blue;
      case MemberStatusType.suspended:
      case MemberStatusType.terminated:
      case MemberStatusType.expelled:
        return StatusPillType.red;
      case MemberStatusType.other:
        return StatusPillType.purple;
      case MemberStatusType.inactive:
      case MemberStatusType.resigned:
      default:
        return StatusPillType.grey;
    }
  }

  static getStatusPillTypeForFacilityStatus(
    facilityStatusTypeId: FacilityStatusType | null | undefined,
  ): StatusPillType {
    switch (facilityStatusTypeId) {
      case FacilityStatusType.active:
        return StatusPillType.green;
      case FacilityStatusType.inactive:
      default:
        return StatusPillType.grey;
    }
  }

  static getStatusPillTypeForMemberEmployerStatus(
    memberEmployerStatusId: MemberEmployerStatusType | undefined,
  ): StatusPillType {
    switch (memberEmployerStatusId) {
      case MemberEmployerStatusType.primary:
        return StatusPillType.green;
      case MemberEmployerStatusType.secondary:
        return StatusPillType.blue;
      case MemberEmployerStatusType.previous:
        return StatusPillType.grey;
      default:
        return StatusPillType.forbidden;
    }
  }

  static getStatusPillTypeForEventStatus(eventStatusId: EventStatusTypeId | undefined): StatusPillType {
    switch (eventStatusId) {
      case EventStatusTypeId.Draft:
        return StatusPillType.purple;
      case EventStatusTypeId.Active:
        return StatusPillType.green;
      case EventStatusTypeId.Past:
        return StatusPillType.grey;
      case EventStatusTypeId.Cancelled:
        return StatusPillType.red;
      default:
        return StatusPillType.forbidden;
    }
  }
  static getStatusPillTypeForTaxRateStatus(taxRateType: TaxRateType): StatusPillType {
    switch (taxRateType) {
      case TaxRateType.Upcoming:
        return StatusPillType.blue;
      case TaxRateType.Current:
        return StatusPillType.green;
      case TaxRateType.Ended:
      default:
        return StatusPillType.grey;
    }
  }

  static getStatusPillTypeForInvoiceStatus(invoiceStatusType: InvoiceStatusType | null | undefined): StatusPillType {
    switch (invoiceStatusType) {
      case InvoiceStatusType.Draft:
        return StatusPillType.purple;
      case InvoiceStatusType.Issued:
        return StatusPillType.blue;
      case InvoiceStatusType.Overdue:
        return StatusPillType.red;
      case InvoiceStatusType.PartiallyPaid:
        return StatusPillType.yellow;
      case InvoiceStatusType.Paid:
        return StatusPillType.green;
      case InvoiceStatusType.Void:
      case InvoiceStatusType.Refunded:
      default:
        return StatusPillType.grey;
    }
  }

  static getStatusPillTypeForEventRegistrationStatus(
    eventRegistrationStatus: EventRegistrationStatus | null | undefined,
  ): StatusPillType {
    switch (eventRegistrationStatus) {
      case EventRegistrationStatus.Registered:
        return StatusPillType.green;
      case EventRegistrationStatus.Waitlisted:
        return StatusPillType.yellow;
      case EventRegistrationStatus.Withdrawn:
      default:
        return StatusPillType.grey;
    }
  }

  static getStatusPillTypeForAlertStatus(alertStatus: AlertStatus | null | undefined): StatusPillType {
    switch (alertStatus) {
      case AlertStatus.Active:
        return StatusPillType.green;
      case AlertStatus.Scheduled:
        return StatusPillType.purple;
      case AlertStatus.Past:
      default:
        return StatusPillType.grey;
    }
  }
}
